import EventGenerator from './EventGenerator.jsx';
import './EventGenerator.css';

export default EventGenerator;
